module.exports = __webpack_public_path__ + "static/ritual-link-2fc283152294fba87becf3cc219ae652.jpg";